import React from 'react'
var Spinner = require('react-spinkit')

const MainLoader = () => {
    return (
        <div className='my-5 w-100 d-flex-center-center'>
            <Spinner name='ball-clip-rotate-multiple' color='#20a8d8' />
        </div>
    )
}

export default MainLoader


// WEBPACK FOOTER //
// ./src/components/Loader/MainLoader/MainLoader.js